import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import { Add } from "@mui/icons-material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const AvailabilityForm = ({ onChildData }) => {
  const [availability, setAvailability] = useState({
    notice_period: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAvailability({ ...availability, [name]: value });
    onChildData({ availability: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const output = `availability:\n  notice_period: "${availability.notice_period}"`;

    console.log(output);
    // Process availability as needed
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3,pt:0,pb:2 }}>
       <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="h6">  Availability</Typography>
          </AccordionSummary>
          <AccordionDetails>
          
      <TextField
        fullWidth
        label="Notice Period"
        name="notice_period"
        value={availability.notice_period}
        onChange={handleChange}
        required
        size='small'
        placeholder="e.g., '2 weeks', '1 month'"
      />
      <Button type="submit" variant="contained" sx={{ mt: 2,display:'none' }}>
        Submit
      </Button>
          </AccordionDetails>
        </Accordion>
     
    </Box>
  );
};

export default AvailabilityForm;